// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fundraiser_container__4sF2P{
    position: relative;
    min-height: calc(100vh - 250px);
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 40px;
    background-color: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.Fundraiser_fundraiserFound__6HoJm{
    display: flex;
}
.Fundraiser_leftSide__biSsF{
    width: calc(100% - 523px);
    padding-left: 35px;
    padding-right: 35px;
}
@media(max-width: 1080px){
    .Fundraiser_container__4sF2P{
        min-height: calc(100vh - 235px);
        padding-bottom: 25px;
    }
    .Fundraiser_fundraiserFound__6HoJm{
        flex-direction: column;
    }
    .Fundraiser_leftSide__biSsF{
        width: calc(100% - 70px);
    }
}
@media(max-width: 600px){
    .Fundraiser_container__4sF2P{
        min-height: calc(100vh - 215px);
    }
    .Fundraiser_leftSide__biSsF{
        width: calc(100% - 40px);
        padding-left: 20px;
        padding-right: 20px;
    }
}
.Fundraiser_headerContainer__Wli2Q{
    position: relative;
}
.Fundraiser_header__HSvOr{
    padding-right: 40px;
    text-align: left;
    word-break: normal;
}
.Fundraiser_pencil__6HPjT{
    position: absolute;
    right: 0;
    top: 12px;
    height: 16px;
    width: 16px;
    cursor: pointer;
}
.Fundraiser_namePencil__5X1p9{
    top: 12px;
}
@media(max-width: 600px){
    .Fundraiser_header__HSvOr{
        padding-right: 30px;
    }
    .Fundraiser_namePencil__5X1p9{
        top: 6px;
    }
}
.Fundraiser_carouselContainer__G4\\+B6{
    display: flex;
    justify-content: center;
}
@media(max-width: 1080px){
    .Fundraiser_carouselContainer__G4\\+B6{
        border-bottom: 1px solid #1F363D1A
    }
}
.Fundraiser_carouselContainer__G4\\+B6 .carousel-root{
    width: 100%;
}
.Fundraiser_carousel__kmi5i .slider{
    cursor: pointer;
}
.Fundraiser_carousel__kmi5i .slide img{
    width: 100%;
    max-width: 800px;
    aspect-ratio: 16 / 9;
    border-radius: 30px;
    object-fit: cover;
}
@media(max-width: 1080px){
    .Fundraiser_carousel__kmi5i .thumbs-wrapper{
        margin-bottom: 5px;
    }
}
.Fundraiser_carousel__kmi5i .thumbs{
    display: flex;
    justify-content: center;
    margin-top: 0;
    padding-left: 0;
}
.Fundraiser_carousel__kmi5i .thumb{
    height: 48px;
    width: 85px !important;
    margin-right: 10px;
    padding: 0;
    border: none !important;
    cursor: pointer;
}
.Fundraiser_carousel__kmi5i .thumb img{
    height: 100%;
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
    opacity: 0.5;
}
.Fundraiser_carousel__kmi5i .thumb.selected img{
    opacity: 1;
}
.Fundraiser_desktopDescriptionContainer__lyNj6{
    position: relative;
}
.Fundraiser_description__lMRHu{
    padding-top: 30px;
    padding-bottom: 30px;
    color: #1F363D;
    white-space: pre-wrap;
}
.Fundraiser_desktopDescription__mDSlk{
    padding-right: 40px;
}
.Fundraiser_descriptionPencil__3F9SW{
    top: 33px;
}
.Fundraiser_desktopComments__qr8Fo, .Fundraiser_desktopUpdates__snoVX{
    border-top: 1px solid #1F363D1A;
}
@media(max-width: 1080px){
    .Fundraiser_desktopDescriptionContainer__lyNj6, .Fundraiser_desktopBottomViewHeaders__taybh, .Fundraiser_desktopComments__qr8Fo, .Fundraiser_desktopUpdates__snoVX{
        display: none;
    }
}
.Fundraiser_rightSide__085cs{
    width: 383px;
    margin-top: 38px;
    padding-left: 35px;
    padding-right: 35px;
}
@media(max-width: 1080px){
    .Fundraiser_rightSide__085cs{
        width: calc(100% - 70px);
        margin-top: 30px;
    }
}
@media(max-width: 600px){
    .Fundraiser_rightSide__085cs{
        width: calc(100% - 40px);
        margin-top: 25px;
        padding-left: 20px;
        padding-right: 20px;
    }
}
.Fundraiser_requestAction__qCR0\\+, .Fundraiser_requestStatus__hq2r6, .Fundraiser_countdownClock__H8MEz{
    margin-bottom: 15px;
}
@media(max-width: 1080px){
    .Fundraiser_requestAction__qCR0\\+, .Fundraiser_requestStatus__hq2r6, .Fundraiser_countdownClock__H8MEz{
        margin-bottom: 30px;
    }
}
@media(max-width: 600px){
    .Fundraiser_requestAction__qCR0\\+, .Fundraiser_requestStatus__hq2r6, .Fundraiser_countdownClock__H8MEz{
        margin-bottom: 25px;
    }
}
.Fundraiser_mobileDescriptionContainer__HohRF{
    display: none;
    position: relative;
    width: calc(100% - 100px);
    margin-left: 35px;
    margin-right: 35px;
    padding-right: 30px;
}
.Fundraiser_mobileBottomViewHeaders__\\+mFMN, .Fundraiser_mobileComments__fojzz, .Fundraiser_mobileUpdates__B\\+rDB{
    display: none;
    width: calc(100% - 70px);
    padding-left: 35px;
    padding-right: 35px;
}
@media(max-width: 1080px){
    .Fundraiser_mobileDescriptionContainer__HohRF, .Fundraiser_mobileBottomViewHeaders__\\+mFMN, .Fundraiser_mobileComments__fojzz, .Fundraiser_mobileUpdates__B\\+rDB{
        display: block;
    }
}
@media(max-width: 600px){
    .Fundraiser_mobileDescriptionContainer__HohRF, .Fundraiser_mobileBottomViewHeaders__\\+mFMN{
        width: calc(100% - 70px);
    }
    .Fundraiser_mobileComments__fojzz, .Fundraiser_mobileUpdates__B\\+rDB{
        width: calc(100% - 40px);
    }
    .Fundraiser_mobileDescriptionContainer__HohRF{
        margin-left: 20px;
        margin-right: 20px;
    }
    .Fundraiser_mobileBottomViewHeaders__\\+mFMN, .Fundraiser_mobileComments__fojzz, .Fundraiser_mobileUpdates__B\\+rDB{
        padding-left: 20px;
        padding-right: 20px;
    }
}
.Fundraiser_fundraiserNotFound__DoLB-{
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 500px;
    text-align: center;
}
@media(max-width: 600px){
    .Fundraiser_fundraiserNotFound__DoLB-{
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: calc(100% - 40px);
        text-align: center;
    }
}
.Fundraiser_brokenHeart__E9pkL{
    height: 60px;
    width: 60px;
    margin-top: calc(40% - 50px);
    margin-bottom: 30px;
}
.Fundraiser_fundraiserNotFoundDescription__y2K3F{
    color: #1F363D;
    text-align: center;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
    line-height: 37px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Fundraiser.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,+BAA+B;QAC/B,oBAAoB;IACxB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,+BAA+B;IACnC;IACA;QACI,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,SAAS;AACb;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,QAAQ;IACZ;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,eAAe;AACnB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,+BAA+B;AACnC;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,wBAAwB;QACxB,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,wBAAwB;QACxB,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,mBAAmB;AACvB;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI;QACI,OAAO;QACP,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;QAClB,wBAAwB;QACxB,kBAAkB;IACtB;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,iBAAiB;AACrB","sourcesContent":[".container{\n    position: relative;\n    min-height: calc(100vh - 250px);\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding-bottom: 40px;\n    background-color: #FFFFFF;\n    border-radius: 30px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.fundraiserFound{\n    display: flex;\n}\n.leftSide{\n    width: calc(100% - 523px);\n    padding-left: 35px;\n    padding-right: 35px;\n}\n@media(max-width: 1080px){\n    .container{\n        min-height: calc(100vh - 235px);\n        padding-bottom: 25px;\n    }\n    .fundraiserFound{\n        flex-direction: column;\n    }\n    .leftSide{\n        width: calc(100% - 70px);\n    }\n}\n@media(max-width: 600px){\n    .container{\n        min-height: calc(100vh - 215px);\n    }\n    .leftSide{\n        width: calc(100% - 40px);\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n.headerContainer{\n    position: relative;\n}\n.header{\n    padding-right: 40px;\n    text-align: left;\n    word-break: normal;\n}\n.pencil{\n    position: absolute;\n    right: 0;\n    top: 12px;\n    height: 16px;\n    width: 16px;\n    cursor: pointer;\n}\n.namePencil{\n    top: 12px;\n}\n@media(max-width: 600px){\n    .header{\n        padding-right: 30px;\n    }\n    .namePencil{\n        top: 6px;\n    }\n}\n.carouselContainer{\n    display: flex;\n    justify-content: center;\n}\n@media(max-width: 1080px){\n    .carouselContainer{\n        border-bottom: 1px solid #1F363D1A\n    }\n}\n.carouselContainer :global(.carousel-root){\n    width: 100%;\n}\n.carousel :global(.slider){\n    cursor: pointer;\n}\n.carousel :global(.slide img){\n    width: 100%;\n    max-width: 800px;\n    aspect-ratio: 16 / 9;\n    border-radius: 30px;\n    object-fit: cover;\n}\n@media(max-width: 1080px){\n    .carousel :global(.thumbs-wrapper){\n        margin-bottom: 5px;\n    }\n}\n.carousel :global(.thumbs){\n    display: flex;\n    justify-content: center;\n    margin-top: 0;\n    padding-left: 0;\n}\n.carousel :global(.thumb){\n    height: 48px;\n    width: 85px !important;\n    margin-right: 10px;\n    padding: 0;\n    border: none !important;\n    cursor: pointer;\n}\n.carousel :global(.thumb img){\n    height: 100%;\n    width: 100%;\n    border-radius: 10px;\n    object-fit: cover;\n    opacity: 0.5;\n}\n.carousel :global(.thumb.selected img){\n    opacity: 1;\n}\n.desktopDescriptionContainer{\n    position: relative;\n}\n.description{\n    padding-top: 30px;\n    padding-bottom: 30px;\n    color: #1F363D;\n    white-space: pre-wrap;\n}\n.desktopDescription{\n    padding-right: 40px;\n}\n.descriptionPencil{\n    top: 33px;\n}\n.desktopComments, .desktopUpdates{\n    border-top: 1px solid #1F363D1A;\n}\n@media(max-width: 1080px){\n    .desktopDescriptionContainer, .desktopBottomViewHeaders, .desktopComments, .desktopUpdates{\n        display: none;\n    }\n}\n.rightSide{\n    width: 383px;\n    margin-top: 38px;\n    padding-left: 35px;\n    padding-right: 35px;\n}\n@media(max-width: 1080px){\n    .rightSide{\n        width: calc(100% - 70px);\n        margin-top: 30px;\n    }\n}\n@media(max-width: 600px){\n    .rightSide{\n        width: calc(100% - 40px);\n        margin-top: 25px;\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n.requestAction, .requestStatus, .countdownClock{\n    margin-bottom: 15px;\n}\n@media(max-width: 1080px){\n    .requestAction, .requestStatus, .countdownClock{\n        margin-bottom: 30px;\n    }\n}\n@media(max-width: 600px){\n    .requestAction, .requestStatus, .countdownClock{\n        margin-bottom: 25px;\n    }\n}\n.mobileDescriptionContainer{\n    display: none;\n    position: relative;\n    width: calc(100% - 100px);\n    margin-left: 35px;\n    margin-right: 35px;\n    padding-right: 30px;\n}\n.mobileBottomViewHeaders, .mobileComments, .mobileUpdates{\n    display: none;\n    width: calc(100% - 70px);\n    padding-left: 35px;\n    padding-right: 35px;\n}\n@media(max-width: 1080px){\n    .mobileDescriptionContainer, .mobileBottomViewHeaders, .mobileComments, .mobileUpdates{\n        display: block;\n    }\n}\n@media(max-width: 600px){\n    .mobileDescriptionContainer, .mobileBottomViewHeaders{\n        width: calc(100% - 70px);\n    }\n    .mobileComments, .mobileUpdates{\n        width: calc(100% - 40px);\n    }\n    .mobileDescriptionContainer{\n        margin-left: 20px;\n        margin-right: 20px;\n    }\n    .mobileBottomViewHeaders, .mobileComments, .mobileUpdates{\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n.fundraiserNotFound{\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 500px;\n    text-align: center;\n}\n@media(max-width: 600px){\n    .fundraiserNotFound{\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n        width: calc(100% - 40px);\n        text-align: center;\n    }\n}\n.brokenHeart{\n    height: 60px;\n    width: 60px;\n    margin-top: calc(40% - 50px);\n    margin-bottom: 30px;\n}\n.fundraiserNotFoundDescription{\n    color: #1F363D;\n    text-align: center;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n    line-height: 37px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Fundraiser_container__4sF2P`,
	"fundraiserFound": `Fundraiser_fundraiserFound__6HoJm`,
	"leftSide": `Fundraiser_leftSide__biSsF`,
	"headerContainer": `Fundraiser_headerContainer__Wli2Q`,
	"header": `Fundraiser_header__HSvOr`,
	"pencil": `Fundraiser_pencil__6HPjT`,
	"namePencil": `Fundraiser_namePencil__5X1p9`,
	"carouselContainer": `Fundraiser_carouselContainer__G4+B6`,
	"carousel": `Fundraiser_carousel__kmi5i`,
	"desktopDescriptionContainer": `Fundraiser_desktopDescriptionContainer__lyNj6`,
	"description": `Fundraiser_description__lMRHu`,
	"desktopDescription": `Fundraiser_desktopDescription__mDSlk`,
	"descriptionPencil": `Fundraiser_descriptionPencil__3F9SW`,
	"desktopComments": `Fundraiser_desktopComments__qr8Fo`,
	"desktopUpdates": `Fundraiser_desktopUpdates__snoVX`,
	"desktopBottomViewHeaders": `Fundraiser_desktopBottomViewHeaders__taybh`,
	"rightSide": `Fundraiser_rightSide__085cs`,
	"requestAction": `Fundraiser_requestAction__qCR0+`,
	"requestStatus": `Fundraiser_requestStatus__hq2r6`,
	"countdownClock": `Fundraiser_countdownClock__H8MEz`,
	"mobileDescriptionContainer": `Fundraiser_mobileDescriptionContainer__HohRF`,
	"mobileBottomViewHeaders": `Fundraiser_mobileBottomViewHeaders__+mFMN`,
	"mobileComments": `Fundraiser_mobileComments__fojzz`,
	"mobileUpdates": `Fundraiser_mobileUpdates__B+rDB`,
	"fundraiserNotFound": `Fundraiser_fundraiserNotFound__DoLB-`,
	"brokenHeart": `Fundraiser_brokenHeart__E9pkL`,
	"fundraiserNotFoundDescription": `Fundraiser_fundraiserNotFoundDescription__y2K3F`
};
export default ___CSS_LOADER_EXPORT___;
